import { render, staticRenderFns } from "./InputTextAreaVariable.vue?vue&type=template&id=65b59f28&scoped=true&"
import script from "./InputTextAreaVariable.vue?vue&type=script&lang=js&"
export * from "./InputTextAreaVariable.vue?vue&type=script&lang=js&"
import style0 from "./InputTextAreaVariable.vue?vue&type=style&index=0&id=65b59f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b59f28",
  null
  
)

export default component.exports